// Product page "Related products" / "Recommended Accessories" / "Accessories For"
// sections all share the same markup (section.related.products > ul.products), so
// they are converted into Swiper sliders here instead of wrapping onto new rows.
// Slide widths are CSS-driven (slidesPerView: 'auto') because the theme's product
// grid rules use !important widths that would fight Swiper's inline sizing.
document.addEventListener('DOMContentLoaded', function () {
  var isRelatedSurface = document.body.classList.contains('single-product') || document.body.classList.contains('woocommerce-order-received');

  if (typeof Swiper === 'undefined' || !isRelatedSurface) {
    return;
  }

  var sections = document.querySelectorAll('section.related.products');

  sections.forEach(function (section) {
    var list = section.querySelector('ul.products');

    if (!list) {
      return;
    }

    var slides = Array.prototype.filter.call(list.children, function (el) {
      return el.tagName === 'LI';
    });

    if (slides.length < 2) {
      return;
    }

    var container = document.createElement('div');
    container.className = 'swiper related-products-swiper';
    list.parentNode.insertBefore(container, list);
    container.appendChild(list);

    list.classList.add('swiper-wrapper');
    slides.forEach(function (li) {
      li.classList.add('swiper-slide');
    });

    var makeNavButton = function (dir, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'related-products-nav related-products-nav--' + dir;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<i class="fa-solid fa-chevron-' + dir + '" aria-hidden="true"></i>';
      container.appendChild(button);
      return button;
    };

    var prevEl = makeNavButton('left', 'Previous products');
    var nextEl = makeNavButton('right', 'Next products');

    var scrollbarEl = document.createElement('div');
    scrollbarEl.className = 'swiper-scrollbar';
    container.appendChild(scrollbarEl);

    // Styling hook: enables the slider CSS (and its no-JS grid fallback sibling).
    section.classList.add('has-products-slider');

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 400,
      watchOverflow: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
        disabledClass: 'is-disabled',
        lockClass: 'is-locked',
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      on: {
        lock: function () { container.classList.add('slides-fit'); },
        unlock: function () { container.classList.remove('slides-fit'); },
      },
    });
  });
});
